import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { urls } = app?.backend;

export class UserLlmModelSelectService {
    static getClassName = () => {
        return 'UserLlmModelSelectService - class'
    }

    static getAll = async ({
        initialLoad = false,
        token = '',
        languageId = 'en',
        subMethod = '',
    } = {}) => {
        const currentMethod = `${this?.getClassName()} / getAll`;
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.userLlmModelSelects}/`;
            const headers = { authorization: `bearer ${token}`, initialLoad: initialLoad, languageId: languageId };
            response = await axiosV2?.get({
                url: url,
                headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static getByConditionals = async ({
        data = {},
        token = '',
        languageId = 'en',
        subMethod = '',
    } = {}) => {
        const currentMethod = `${this?.getClassName()} / getByConditionals`;
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.userLlmModelSelects}/`;
            const headers = { authorization: `bearer ${token}`, languageId: languageId };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static getById = async ({
        id = '',
        token = '',
        languageId = 'en',
        subMethod = '',
    } = {}) => {
        const currentMethod = `${this?.getClassName()} / getById`;
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.userLlmModelSelects}/${id}`;
            const headers = { authorization: `bearer ${token}`, languageId: languageId };
            response = await axiosV2?.get({
                url: url,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    //#region old code
    // static delete = async ({
    //     id = '',
    //     token = '',
    //     languageId = '',
    //     subMethod = '',
    // } = {}) => {
    //     const currentMethod = `${this?.getClassName()} / delete`;
    //     let response = getResponse({ type: 0 });
    //     try {
    //         const url = `${urls?.url}${urls?.apiV1}${urls?.userLlmModelSelects}/${id}`;
    //         const headers = { authorization: `bearer ${token}`, languageId: languageId };
    //         response = await axiosV2?.delete({
    //             url: url,
    //             headers: headers,
    //             subMethod: currentMethod
    //         });
    //         if (!response?.isSuccess || response?.isWarning) return response;

    //     } catch (ex) {
    //         response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    //     }
    //     return response;
    // }
    //#endregion old code

    //#region old code
    // static create = async ({
    //     data = {},
    //     token = '',
    //     subMethod = '',
    // } = {}) => {
    //     const currentMethod = `${this?.getClassName()} / create`;
    //     let response = getResponse({ type: 0 });
    //     try {
    //         const url = `${urls?.url}${urls?.apiV1}${urls?.userLlmModelSelects}/`;
    //         const headers = { authorization: `bearer ${token}` };
    //         response = await axiosV2?.post({
    //             url: url,
    //             data: data,
    //             headers: headers,
    //             subMethod: currentMethod
    //         });
    //         if (!response?.isSuccess || response?.isWarning) return response;

    //     } catch (ex) {
    //         response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    //     }
    //     return response;
    // }
    //#endregion old code
    
    static update = async ({
        id = '',
        data = {},
        token = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = `${this?.getClassName()} / update`;
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.userLlmModelSelects}/${id}`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
}
